import { Link } from "react-router-dom";
import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20warm%20deep%20orange%20and%20dark%20gradients%2C%20swirling%20smoke-like%20textures%2C%20cinematic%20noir%20atmosphere%2C%20dark%20mysterious%20backdrop%20with%20subtle%20spotlight%20effects%2C%20rich%20amber%20and%20crimson%20accents%2C%20no%20text%20no%20people%2C%20artistic%20abstract%20photography%20with%20dramatic%20lighting&width=1920&height=1080&seq=home-hero-bg-01&orientation=landscape"
          alt="51每日大赛背景"
          className="w-full h-full object-cover object-top"
          title="51每日大赛 - 24小时不打烊爆料站"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-12">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-16">
          {/* Left: Title */}
          <div className="flex-1 text-center lg:text-left w-full">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-background-50 leading-tight tracking-tight">
              {heroData.title}
            </h1>
            <p className="mt-4 md:mt-6 text-xl md:text-3xl font-heading text-accent-300 tracking-wider">
              {heroData.subtitle}
            </p>
          </div>

          {/* Right: Description + CTA */}
          <div className="flex-1 flex flex-col items-center lg:items-start gap-6 w-full">
            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-md text-center lg:text-left">
              {heroData.description}
            </p>
            <Link
              to="/content"
              className="group flex items-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-background-50 text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              {heroData.ctaText}
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>

        {/* Bottom hero image */}
        <div className="mt-12 md:mt-16 max-w-6xl mx-auto">
          <div className="relative w-full h-[280px] md:h-[400px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20newsroom%20with%20multiple%20glowing%20screens%20showing%20blurred%20social%20media%20feeds%2C%20warm%20amber%20atmospheric%20lighting%2C%20breaking%20news%20vibe%2C%20cinematic%20composition%2C%20no%20people%2C%20high%20tech%20monitoring%20room%20aesthetic%2C%20mysterious%20and%20intense%20mood&width=1600&height=800&seq=home-hero-sub-01&orientation=landscape"
              alt="热搜现场"
              className="w-full h-full object-cover object-top"
              title="51每日大赛热搜追踪"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-900/70 backdrop-blur-sm text-accent-300 text-xs md:text-sm font-medium">
                <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
                实时追踪中 · 最新爆料
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-xs text-background-200/60">向下滚动</span>
        <i className="ri-arrow-down-line text-background-200/60 animate-bounce"></i>
      </div>
    </section>
  );
}